import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SellerId,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}salesForce/worktype`;

interface GetWorkTypeBySellerQueryPayload {
  sellerId: SellerId;
}

type GetWorkTypeBySellerQueryResponse = { id: string; label: string }[];

type GetWorkTypeBySellerQuery = (
  payload: GetWorkTypeBySellerQueryPayload,
) => Promise<
  BackResponse<GetWorkTypeBySellerQueryResponse> | BackResponseFailure
>;

const getWorkTypeBySellerQuery: GetWorkTypeBySellerQuery = async ({
  sellerId,
}) => {
  try {
    return await apiCall<BackResponse<GetWorkTypeBySellerQueryResponse>>(
      buildUrl(ENDPOINT, { sellerId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getWorkTypeBySellerQuery;
